import { IconBase, type IconProps } from './IconBase';

/** Generic "code host" mark used on the GitHub sign-in button (no third-party logo artwork). */
export function GithubIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M8 18c-3 1-3-1.5-4-2M14 21v-3.5c0-1 .1-1.4-.5-2 2.8-.3 5.5-1.4 5.5-6a4.6 4.6 0 0 0-1.3-3.2 4.2 4.2 0 0 0-.1-3.2s-1-.3-3.4 1.3a11.7 11.7 0 0 0-6.2 0C5.6 2.8 4.6 3.1 4.6 3.1a4.2 4.2 0 0 0-.1 3.2A4.6 4.6 0 0 0 3.2 9.5c0 4.6 2.7 5.7 5.5 6-.6.6-.6 1.2-.5 2V21" />
    </IconBase>
  );
}
